function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.445 20.739h-5.73v-1.387h5.274l-.835-2.543h-3.98c-1.194 1.14-2.298 2.187-3.287 3.543L10.832 21.8l-1.055-1.447c-.998-1.368-2.127-2.435-3.288-3.543H2.51l-.835 2.543h5.274v1.387h-5.73l-.79 2.404h20.807l-.79-2.404z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.832 19.583c3.147-4.315 7.628-5.98 7.628-11.097 0-4.372-3.257-7.629-7.628-7.629-4.37 0-7.63 3.257-7.63 7.63 0 5.116 4.483 6.782 7.63 11.096zm0-12.89c1.146 0 2.08.934 2.08 2.08s-.934 2.08-2.08 2.08a2.085 2.085 0 01-2.081-2.08c0-1.146.934-2.08 2.08-2.08z",
  fill: "#fff"
});

function SvgIconProspects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconProspects;